import { useEffect, useRef, useState } from "react";
import api from "../lib/api";
import { Bell } from "lucide-react";

export const NotificationBell = () => {
  const [data, setData] = useState({ notifications: [], unread: 0 });
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const load = () => api.get("/notifications").then((r) => setData(r.data)).catch(() => {});

  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const toggle = async () => {
    const next = !open;
    setOpen(next);
    if (next && data.unread > 0) {
      await api.post("/notifications/mark-read").catch(() => {});
      setTimeout(load, 500);
    }
  };

  return (
    <div className="relative" ref={ref}>
      <button data-testid="notification-bell" onClick={toggle}
        className="relative p-2 text-neutral-500 hover:text-neutral-900 hover:bg-neutral-100 rounded-md transition-colors">
        <Bell size={18} />
        {data.unread > 0 && (
          <span data-testid="notification-unread-badge"
            className="absolute -top-0.5 -right-0.5 bg-red-600 text-white text-[10px] font-bold rounded-full min-w-[16px] h-4 px-1 flex items-center justify-center">
            {data.unread > 9 ? "9+" : data.unread}
          </span>
        )}
      </button>
      {open && (
        <div data-testid="notification-panel"
          className="absolute right-0 mt-2 w-96 bg-white border border-neutral-200 rounded-lg shadow-lg z-50 overflow-hidden">
          <div className="px-4 py-3 border-b border-neutral-100 font-semibold font-heading text-sm">Notifications</div>
          <div className="max-h-96 overflow-y-auto divide-y divide-neutral-100">
            {data.notifications.length === 0 && <p className="p-4 text-sm text-neutral-400">Nothing yet.</p>}
            {data.notifications.map((n) => (
              <div key={n.id} className={`px-4 py-3 ${n.read ? "" : "bg-blue-50/50"}`}>
                <p className="text-sm font-medium text-neutral-900 leading-snug">{n.subject}</p>
                <p className="text-xs text-neutral-400 mt-1">{new Date(n.created_at).toLocaleString()}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
